import { canFilter } from '../../mixins/can_filter';
import { canPaginate } from '../../mixins/can_paginate';
import { NEW_ADMIN_URL } from 'environment';

angular
.module('app.views')
.config(($routeProvider) => {
    $routeProvider.when('/accounts/:account_id/storage_bills', {
        template: require('./account_storage_bills.html'),
        controller: 'AccountStorageBillsController'
    });
})
.controller('AccountStorageBillsController', function($scope, $location, $routeParams, Account, AccountStorageBill) {
    canFilter($scope, $location);
    canPaginate($scope, $location);
    $scope.newAdminURL = NEW_ADMIN_URL;
    $scope.s || ($scope.s = '-starts_at');

    const params = _.pick($scope, 'q', 's', 'p');
    params.account_id = $routeParams.account_id;
    params['filter.is_archived'] = 'false';

    $scope.storageBills = AccountStorageBill.query(params, function(data, getResponseHeader) {
        const pagination = getResponseHeader('X-Pagination');
        return $scope.pagination = (pagination ? JSON.parse(pagination) : {});
    });
    $scope.account = Account.get({ id: $routeParams.account_id });

    $scope.peek = () => {
        const now = new Date();
        let year = now.getUTCFullYear();
        let month = now.getUTCMonth();
        let startsAt = new Date((new Date(year, month, 1)).getTime() - now.getTimezoneOffset() * 60000);
        month += 1;
        if (month > 11) {
            year += 1;
            month = 0;
        }
        let endsAt = new Date((new Date(year, month, 1)).getTime() - 1000 - now.getTimezoneOffset() * 60000);

        $location.url(`/storage_bill/peek?account_id=${$routeParams.account_id}&starts_at=${startsAt.toISOString()}&ends_at=${endsAt.toISOString()}`);
    }
});


// WEBPACK FOOTER //
// ./views/account/account_storage_bills_controller.js